"use client";
import { branchConfig } from "@/lib/branchConfig";
import { MobileHeaderShell, DesktopHeaderShell, LanguageSwitcher, AuthIconSlot } from "@kkeut/ui/header";
import { useMobileSidebarState, cartState } from "@/store/MobileSidebarState";
import { useLocale } from "@/components/LocaleProvider";
import { LOCALES } from '@kkeut/lib/locale';
import useSwitchLocale from "@/hooks/useSwitchLocale";

function LocaleSwitch() {
  const { locale, setLocale } = useLocale();
  const { switchLocale } = useSwitchLocale?.() || {};
  return <LanguageSwitcher locales={LOCALES} locale={locale} setLocale={setLocale} switchLocale={switchLocale} />;
}

export function MobileHeader({ showAuthIcon = false, branches = null }) {
  const { toggle } = useMobileSidebarState();
  const { locale } = useLocale();
  return (
    <MobileHeaderShell
      logoAlt={branchConfig.titleTail?.ko}
      branches={branches}
      cartState={cartState}
      onMobileMenuToggle={toggle}
      languageSwitcherSlot={<LocaleSwitch />}
      userIconSlot={showAuthIcon ? <AuthIconSlot size={20} locale={locale} /> : undefined}
    />
  );
}

export function Header({ initialMenu = null, showAuthIcon = false, branches = null }) {
  const { locale } = useLocale();
  return (
    <DesktopHeaderShell
      logoAlt={branchConfig.titleTail?.ko}
      branches={branches}
      initialMenu={initialMenu || []}
      useInitialMenu={initialMenu?.length > 0}
      cartState={cartState}
      languageSwitcherSlot={<LocaleSwitch />}
      userIconSlot={showAuthIcon ? <AuthIconSlot size={24} locale={locale} /> : undefined}
      showTopUserIcon={showAuthIcon}
    />
  );
}
